<template>
  <el-descriptions
    title="Study information" 
    border
    size="large"
    :column="3"
  >
    <el-descriptions-item label="Study":span="3">
      {{studyInfo.study_id}}
    </el-descriptions-item>
    <el-descriptions-item label="Trait" :span="3">
      {{studyInfo.trait}}
    </el-descriptions-item>
    <el-descriptions-item label="MeSH Term" :span="3">
      {{studyInfo.MeSH_term}}
    </el-descriptions-item>
    <el-descriptions-item label="Trait Type" :span="3">
      {{studyInfo.trait_type}}
    </el-descriptions-item>
    <el-descriptions-item label="NControl">
      {{studyInfo.n_control}}
    </el-descriptions-item>
    <el-descriptions-item label="NCase">
      {{studyInfo.n_case}}
    </el-descriptions-item>
    <el-descriptions-item label="Sample Size">
      {{studyInfo.sample_size}}
    </el-descriptions-item>
    <el-descriptions-item label="Population" :span="3">
      {{studyInfo.population}}
    </el-descriptions-item>
    <el-descriptions-item label="PMID" :span="3">
      <template v-slot="scope">
        <a v-if="studyInfo.PMID !== ''" class="pmid" :href="'https://pubmed.ncbi.nlm.nih.gov/'+studyInfo.PMID" target="_blank">{{studyInfo.PMID}}</a>
      </template>
    </el-descriptions-item>
    <el-descriptions-item label="Download" :span="3">
      <template v-slot="scope">
        <a  :href="'https://cardiogene-1315664645.cos.ap-hongkong.myqcloud.com/GWAS/'+studyInfo.study_id+'.txt.gz'" target="_blank"><downloadOutlined/></a>
      </template>
    </el-descriptions-item>
  </el-descriptions>
  <div>
    <div style="color: red;">Tips: click on the specific method button to view the detailed result of corresponding analysis</div>
    <div style="font-size: 16px; font-weight: bold; color: #303133;">Analysis</div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="SNP Level" name="1">
        <router-link
          class="table_method"
          v-for="value in snp_level"
          :key="value"
          :to="{
            name:changeMethod(value),
            params:{
              study:studyInfo.study_id
            }
          }"
          target="_blank"
          >
          {{ value }}
        </router-link>
      </el-collapse-item>
      <el-collapse-item title="Genetic Overlap" name="2">
        <router-link
          class="table_method"
          v-for="value in genetic_overlap"
          :key="value"
          :to="{
            name:changeMethod(value),
            params:{
              study:studyInfo.study_id
            }
          }"
          target="_blank"
          >
          {{ value }}
        </router-link>
      </el-collapse-item>
      <el-collapse-item title="Functional Annotations" name="3">
        <router-link
          class="table_method"
          v-for="value in functional_annotations"
          :key="value"
          :to="{
            name:changeMethod(value),
            params:{
              study:studyInfo.study_id
            }
          }"
          target="_blank"
          >
          {{ value }}
        </router-link>
      </el-collapse-item>
      <el-collapse-item title="Gene Level" name="4">
        <router-link
          class="table_method"
          v-for="value in gene_level"
          :key="value"
          :to="{
            name:changeMethod(value),
            params:{
              study:studyInfo.study_id
            }
          }"
          target="_blank"
          >
          {{ value }}
        </router-link>
      </el-collapse-item>
      <el-collapse-item title="Causal Inference" name="5">
        <router-link
          class="table_method"
          v-for="value in causal_inference"
          :key="value"
          :to="{
            name:changeMethod(value),
            params:{
              study:studyInfo.study_id
            }
          }"
          target="_blank"
          >
          {{ value }}
        </router-link>
      </el-collapse-item>
    </el-Collapse>
  </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from 'vue'
import { ElDescriptions, ElDescriptionsItem, ElCollapse, ElCollapseItem } from 'element-plus';
import { useRoute } from 'vue-router';
import { DownloadOutlined } from '@ant-design/icons-vue'

export default {
  name: 'Study',
  components: {
    ElDescriptions,
    ElDescriptionsItem,
    ElCollapse,
    ElCollapseItem,
    DownloadOutlined
  },
  setup(){
    const { proxy } = getCurrentInstance()
    var studyInfo = ref([])
    var methods = ref([])
    var snp_level = ref([])
    var genetic_overlap = ref([])
    var functional_annotations = ref([])
    var gene_level = ref([])
    var causal_inference = ref([])
    const activeNames = ref(['1', '2', '3', '4', '5'])
    const route = useRoute()
    var study = ref(route.params.study)
    const fetchStudyData = async() => {
      try {
        const response = await proxy.$request.get('/getStudyInfo',{
          params: {
            study: study.value
        }});
        studyInfo.value = response.data
        studyInfo.value.trait_type = studyInfo.value.trait_type == 0 ? 'binary' : 'quantitative'
        methods.value = response.data.method.split(";")
        if(methods.value.includes('FineMapping')){
          snp_level.value.push('FineMapping')
        }
        if(methods.value.includes('LDAK')){
          genetic_overlap.value.push('LDAK')
        }
        if(methods.value.includes('LDSC')){
          genetic_overlap.value.push('LDSC')
        }
        if(methods.value.includes('GARFIELD')){
          functional_annotations.value.push('GARFIELD')
        }
        if(methods.value.includes('MAGMA')){
          functional_annotations.value.push('MAGMA')
        }
        if(methods.value.includes('TWAS')){
          gene_level.value.push('TWAS')
        }
        if(methods.value.includes('SMR')){
          gene_level.value.push('SMR')
        }
        if(methods.value.includes('COLOC')){
          gene_level.value.push('COLOC')
        }
        if(methods.value.includes('TSMR')){
          causal_inference.value.push('TSMR')
        }
        console.log('11', snp_level.value)
      } catch (error){
        console.log('fail', error.message)
      }
    }

    const changeMethod = (method) => {
      if (method === "LDAK" || method === "LDSC"){
        return 'Heritability'
      }
      return method
    }

    onMounted(() => {
      fetchStudyData()
    })

    return {
      studyInfo,
      methods,
      snp_level,
      genetic_overlap,
      functional_annotations,
      gene_level,
      causal_inference,
      activeNames,
      fetchStudyData,
      changeMethod
    }
  }
}
</script>

<style scoped>
.el-descriptions {
    margin-top: 20px;
    margin-bottom: 20px;
}
.el-collapse {
    margin-top: 20px;
    margin-bottom: 20px;
}
.table_method{
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
    margin: .5ch;
    border: 1px solid rgb(189, 189, 189);
    padding: 0 10px;
    border-radius: 16px;
    height: 30px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color, 0.3s ease-in-out;
  }
.table_method:hover{
    background-color: rgb(235, 235, 235);
  }
</style>